import { useUpdate } from "@/core/hooks/use-update.hook";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Popover, Radio, RadioChangeEvent, Space } from "antd";
import { useState } from "react";
import { debounce } from "ts-debounce";

export enum SearchMode {
    include = 'include',
    notInclude = 'notInclude',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    equals = 'equals',
}

export interface ColumnSearchPayload {
    value: string,
    mode: SearchMode,
    dataIndex: string
}

export const ColumnSearch: React.FC<ColumnSearchProps> = ({dataIndex, onChange})  => {
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [searchMode, setSearchMode] = useState<SearchMode>(SearchMode.include);

    useUpdate(() => {
        onChange({
            mode: searchMode,
            value: searchQuery,
            dataIndex: dataIndex
        })
    }, [searchQuery, searchMode]);

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        setSearchQuery(event.target.value);
    }


    function onSearchModeChange(event: RadioChangeEvent) {
        setSearchMode(event.target.value);
    }

    function handleReset() {
        setSearchMode(SearchMode.include);
        setSearchQuery("");
    }


    return <div className="flex flex-row items-center mr-1.5">
        <Input
            variant="borderless" onChange={handleChange} value={searchQuery} 
            placeholder="Tìm kiếm" style={{paddingLeft: 8, fontWeight: "normal", color: "#004466"}}
        />
        <Popover content={
            <Space className="mt-1" direction="vertical">
                <Radio.Group onChange={onSearchModeChange} value={searchMode}>
                    <Space direction="vertical">
                        <Radio value={SearchMode.include}>Bao gồm</Radio>
                        <Radio value={SearchMode.notInclude}>Không gồm</Radio>
                        <Radio value={SearchMode.startsWith}>Bắt đầu với</Radio>
                        <Radio value={SearchMode.endsWith}>Kết thúc với</Radio>
                        <Radio value={SearchMode.equals}>Bằng</Radio>
                    </Space>
                </Radio.Group>
                <Button className="my-0.5" color="danger" variant="outlined" onClick={handleReset}>Reset</Button>
            </Space>

        } trigger="click" placement="bottom">
            <SearchOutlined className="hover:bg-slate-300 rounded p-1 duration-200" style={{color: "#052F61"}} />
        </Popover>
    </div>
}

interface ColumnSearchProps {
    dataIndex: string,
    onChange: (event: ColumnSearchPayload) => void
}